import { useState, useEffect } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import Logo from "../../Assests/cosmos  Logo.png";

const Loader = ({ isLoading }) => {
  const [progress, setProgress] = useState(0);
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    let progressTimer;
    let minDisplayTimer;
    let hideLoaderTimer;

    if (isLoading) {
      setProgress(0);
      setShowLoader(true);

      // Progress animation
      progressTimer = setInterval(() => {
        setProgress((prev) => (prev >= 100 ? 100 : prev + 10));
      }, 800);

      // Ensure loader is shown for at least 2 seconds
      minDisplayTimer = setTimeout(() => {
        // If loading is already false after 2 seconds, hide the loader immediately
        if (!isLoading) {
          setShowLoader(false);
        }
      }, 2000);
    }

    // When loading becomes false, check if 2 seconds have passed
    if (!isLoading) {
      hideLoaderTimer = setTimeout(() => {
        setShowLoader(false);
      }, 2000);
    }

    return () => {
      clearInterval(progressTimer);
      clearTimeout(minDisplayTimer);
      clearTimeout(hideLoaderTimer);
    };
  }, [isLoading]);

  if (!showLoader) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        zIndex: 9999,
        backdropFilter: 'blur(5px)',
        transition: 'opacity 0.5s ease-in-out',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 4 }}>
        <Box
          component="img"
          src={Logo}
          alt="Logo"
          sx={{
            width: 180,
            height: 'auto',
            marginBottom: 4,
            animation: 'pulse 2s infinite ease-in-out',
            '@keyframes pulse': {
              '0%': { opacity: 0.6, transform: 'scale(0.98)' },
              '50%': { opacity: 1, transform: 'scale(1.02)' },
              '100%': { opacity: 0.6, transform: 'scale(0.98)' },
            },
          }}
        />

        <CircularProgress 
          variant="determinate" 
          value={progress} 
          size={60} 
          thickness={4}
          sx={{ color: '#05b6b3', marginBottom: 2 }} 
        />

        <Typography variant="h6" sx={{ fontWeight: 600, color: '#2c4b52', marginTop: 2 }}>
          Preparing Your Wellness Experience
        </Typography>

        <Typography variant="body1" sx={{ color: '#5a7a80', textAlign: 'center', maxWidth: '400px', marginTop: 1 }}>
          Relax as we curate your personalized journey to beauty and wellness
        </Typography>
      </Box>
    </Box>
  );
};

export default Loader;
